import type { ComposerDisabledReason } from "./composerTurnPlan";
import type { RemoteRuntimeConnectionState } from "./remoteRuntimeThreadConnection.logic";

export function remoteComposerDisabledReason(
  historyOnly: boolean,
  connection: RemoteRuntimeConnectionState,
  providerReason: ComposerDisabledReason,
): ComposerDisabledReason {
  if (historyOnly) return "This saved conversation no longer has an Environment.";
  switch (connection.kind) {
    case "checking":
      return "Loading Environment…";
    case "offline":
      return "This device is unavailable. Reconnect it to send a message.";
    case "revoked":
    case "unauthorized":
    case "not-enabled":
      return connection.message;
    default:
      return providerReason;
  }
}
